import * as React from "react";
import { Form, Row, Col, notification } from "antd";
import { FormComponentProps } from "antd/lib/form";
import Panel from "src/components/common/Panel/Panel";
import { PbrInputCode } from "src/components/common/PbrInputCode/PbrInputCode";
import { PbrSeparator } from "src/components/common/Separator/Separator";
import ConfirmPassword from "src/components/common/Form/ConfirmPassword/ConfirmPassword";
import { AuthContext } from "src/components/context/AuthContext";
import Button from "src/components/common/Button";
import { LocalStorageEnum } from 'src/services/interfaces/LocalStorageEnum';

function ChangePasswordByCode(props: FormComponentProps & { email: string }) {
  const [loading, setLoading] = React.useState(false);
  const [code, setCode] = React.useState("");
  const [password, setPassword] = React.useState("");
  const authContext = React.useContext(AuthContext);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      if (!errs) {
        setLoading(true);
        try {
          await authContext.forgotPasswordSubmit(props.email, code, password);
          await authContext.signInOfficer(props.email, password);
          localStorage.setItem(LocalStorageEnum.hasPasswordChanged, "true");
        } catch (err) {
          localStorage.setItem(LocalStorageEnum.hasPasswordChanged, "false");
          console.log(err);

          notification.error({
            message: "Falha na solicitação",
            description: "Falha ao tentar atualizar a senha. Por favor tente novamente."
          });
          setLoading(false);
        }
      }
    });
  }

  return (
    <Form onSubmit={e => handleSubmit(e)}>
      <span className="decode-recovery-code-header">
        Enviamos um código de verificação para o e-mail <b>{props.email}</b>.<br />
        Por favor, digite o código abaixo e escolha sua nova senha.
      </span>
      <Panel className="panel">
        <h2 className="decode-recovery-code-title">Código de Verificação</h2>
        <PbrInputCode name="code" onChange={val => setCode(val)} style={{ margin: "50px auto" }} formWrapper={props.form} />
        <PbrSeparator />

        <div style={{ maxWidth: "664px", margin: "auto" }}>
          <ConfirmPassword form={props.form} onChange={e => setPassword(e.target.value)} label="" placeholder="Digite a sua nova senha" />

          <Row className="actions-btn-row" gutter={16}>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Button highlight>Mudar senha</Button>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Button inline loading={loading}
                onClick={() => {
                  authContext.forgotPassword(props.email).finally(() => {
                    notification.info({
                      message: "Código enviado",
                      description: "Um novo código foi enviado para seu e-mail"
                    });
                  });
                }}
              >
                Enviar novo código
              </Button>
            </Col>
          </Row>
        </div>
      </Panel>
    </Form>
  );
}

export default Form.create()(ChangePasswordByCode);



// WEBPACK FOOTER //
// ./src/pages/password-recover/ChangePasswordByCode.tsx